export default __webpack_public_path__ + "static/media/4mm 1.57931cf3.jpg";